import { SortDirection } from '@technocom/common/data';
import type { EntityConfiguration, Schema } from '@technocom/data/core';
import { Dictionary } from '@technocom/data/core';

export interface DictionaryDTO {
  id: number;
  // Наименование
  name: string;
}

/**
 * Базовый класс для простых справочников.
 */
export abstract class DictionaryRef<TData extends DictionaryDTO = DictionaryDTO> extends Dictionary<TData, number> {
  static readonly options: EntityConfiguration = Dictionary.extendOptions({
    namespace: 'dict',
    title: 'Справочное значение',
  });

  static readonly schema: Schema = Dictionary.extend<DictionaryDTO>({
    text: 'name',
    fields: {
      id: {
        type: Number,
        title: 'ID',
        options: {
          order: 0,
        },
      },
      name: {
        type: String,
        title: 'Наименование',
        validation: {
          required: true,
        },
        options: {
          order: 10,
          column: {
            width: 200,
            defaultSort: SortDirection.ASC,
          },
        },
      },
    },
  });
}
